
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -1 26 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.735 3.897C14.81 1.966 15.35 1 16.154 1c.804 0 1.342.966 2.42 2.897l.278.5c.306.549.459.823.697 1.004.239.181.536.248 1.13.383l.54.122c2.091.473 3.137.71 3.386 1.51.248.8-.464 1.633-1.89 3.3l-.369.43c-.405.474-.607.711-.698 1.004-.091.293-.06.609 0 1.24l.056.576c.216 2.224.324 3.336-.328 3.83-.65.495-1.63.044-3.587-.858l-.506-.233c-.557-.256-.835-.384-1.13-.384-.294 0-.573.128-1.129.384l-.506.233c-1.958.902-2.937 1.353-3.588.858-.65-.494-.543-1.606-.328-3.83l.056-.575c.061-.632.092-.948 0-1.24-.09-.294-.293-.53-.698-1.004l-.369-.432c-1.425-1.666-2.138-2.5-1.889-3.3.249-.8 1.294-1.036 3.385-1.509l.54-.122c.595-.135.892-.202 1.13-.383.239-.18.392-.455.698-1.004l.279-.5z","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"opacity":".5","d":"M1 13.612a5.194 5.194 0 014.387-.959M1 8.13c1.097-.548 1.415-.482 2.194-.548M1 2.645l.223-.14c2.365-1.48 4.87-1.879 7.232-1.151l.222.068","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    